import { HeaderFormTypes } from '../types';
export var guidbookHeaderTitlesMap = new Map([
    [HeaderFormTypes.add, function (titles) { return titles.addTitle; }],
    [HeaderFormTypes.edit, function (titles) { return titles.editTitle; }],
    [HeaderFormTypes.filter, function () { return ''; }],
]);
